import { render, staticRenderFns } from "./BenevolentMachine.vue?vue&type=template&id=320f0cba"
import script from "./BenevolentMachine.vue?vue&type=script&lang=js"
export * from "./BenevolentMachine.vue?vue&type=script&lang=js"
import style0 from "./BenevolentMachine.vue?vue&type=style&index=0&id=320f0cba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports